import { useFirebase } from '../../../contexts/FirebaseContext';
import { Modal, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { formatSecondsTimestamp } from '../../utils/utils';

const SeoUpdateInProgressComponent = () => {
  const { seoUpdateInProgress, seoUpdateLogs } = useFirebase();

  return (
    <Modal show={seoUpdateInProgress} size={'xl'} backdrop={'static'} keyboard={false} className={'mt-5'}>
      <Modal.Header>
        <Modal.Title>Aggiornamento SEO in corso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Durante l'aggiornamento non è possibile utilizzare il resto delle funzionalità in questa pagina.</div>
        <div>Questo avviso si chiuderà automaticamente al termine dell'aggiornamento e sarà possibile continuare con l'utilizzo.</div>
      </Modal.Body>
      <Modal.Footer className={'pb-0 overflow-hidden'}>
        <fieldset className={'w-100 mb-0'}>
          <legend className={'d-flex align-items-center'}>
            <span>Log eventi</span> <FontAwesomeIcon size={'xs'} icon={faSyncAlt} spin className={'text-muted ml-2'} />
          </legend>
          {seoUpdateLogs && seoUpdateLogs.length ? (
            <Table
              className={'mb-0'}
              style={{
                marginLeft: '-16px',
                marginRight: '-16px',
                width: 'calc(100% + 32px)',
              }}
            >
              <thead>
                <tr className={'small'}>
                  <td style={{ width: '0', whiteSpace: 'nowrap' }} className={'pl-3'}>
                    Data
                  </td>
                  <td style={{ width: '0', whiteSpace: 'nowrap' }}>GUID</td>
                  <td style={{ whiteSpace: 'nowrap' }}>Evento</td>
                </tr>
              </thead>
              <tbody>
                {seoUpdateLogs.map((e, i, arr) => (
                  <tr className={`small ${i != arr.length - 1 ? 'text-muted' : 'bg-light'}`} key={e.date}>
                    <td style={{ width: '0', whiteSpace: 'nowrap' }} className={'pl-3'}>
                      {formatSecondsTimestamp(Math.floor(e.date / 1000), 'dd/MM/y HH:mm:ss')}
                    </td>
                    <td style={{ width: '0', whiteSpace: 'nowrap' }}>{e.id}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{e.message}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className={'mb-3'}>Nessun evento, in attesa...</div>
          )}
        </fieldset>
      </Modal.Footer>
    </Modal>
  );
};

export { SeoUpdateInProgressComponent as SeoUpdateInProgress };
